import { ACTIONS, KEYS } from "../../_config";
import { ActionExtended } from "../../_config/interfaces/interfaces";

export interface BrandsReducer {
    brands: any[] | null;
}

const initialState: BrandsReducer = {
    brands: null,
};

const brandsReducer = (state = initialState, action: ActionExtended) => {
    switch (action.type) {
        case ACTIONS.BRANDS.SEARCH_BRAND:
            return {
                ...state,
                brands: action.payload,
            };

        default:
            return state;
    }
};

export default brandsReducer;
